import React from 'react';

import './HeaderWidget.scss';
import { slideTitleFormatter } from '../../lib/titleFormatter';

const HeaderWidget = (props) => {
    const style = {
        color: 'white',
        textAlign: 'center',
        display: 'table',
        width: '100%',
        height: '100%',
    };

    if (props.isThumbnail) {
        return (<div style={style} />);
    }

    let content = '';
    const customTitle = props.headerValue !== '' && props.headerValue !== null ? slideTitleFormatter(props.headerValue) : '';

    if (props.showCompanyLogo) {
        content = (<div className="imageContainer textNlogo">
            <img src={props.headerLogoImage} role="presentation" />
            <h1 className="headerWidgetText">{customTitle}</h1>
        </div>);
    } else if (props.isCompetition) {
        let split = customTitle.split(':');
        let contestName = split[0];
        let contestDuration = split[1];
        content = (<div className="banner-wrapper">
            <div className="banner-center">
                <div className="competition-name theme-text" style={{ color: props.customColor }}>
                    {contestName}
                </div>
            </div>
            <div className="sub-banner-wrapper">
                <div className="sub-banner theme-bg" style={{ backgroundColor: props.customColor, color: '#FFFFFF' }} >
                    {contestDuration}</div>
            </div>
        </div>);
    } else {
        content = <h1 className="headerWidgetText">{customTitle}</h1>;
    }

    return (
        <div style={style}>
            {content}
        </div>
    );
};

HeaderWidget.propTypes = {
    headerType: React.PropTypes.string,
    headerValue: React.PropTypes.string,
    headerLogoImage: React.PropTypes.string,
    showCompanyLogo: React.PropTypes.bool,
    isCompetition: React.PropTypes.bool,
    customColor: React.PropTypes.string,
};

export default HeaderWidget;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/HeaderWidget.jsx
 **/